import * as Yup from 'yup';
import {  SERIES_REQUIRED } from '../../../constant/message';

export const industrySchema = Yup.object().shape({
  name: Yup.string().required(SERIES_REQUIRED),
});
